<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title>{{'UPLOAD_CERT' | translate}} <span style="font-size: 0.6em; text-transform: capitalize;">(base-64 encoded X.509)</span></h2>
<hr>

<mat-dialog-content>
    <input #fileInput type="file" accept=".cer" name="certificate" (change)="setFile(fileInput)" />
</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onCancelClick()" type="button">{{'CANCEL' | translate}}</button>
    <button mat-raised-button (click)="upload()" type="button" style="background-color: #194e84; color: white;">{{'ESC_OK' | translate}}</button>
</mat-dialog-actions>
